import { useAuth } from "../context/AuthProvider";
import { useEffect, useState } from "react";

export const useAuthCheck = () => {
    const { AuthenticateUser } = useAuth();
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            const authenticated = await AuthenticateUser();
            setIsAuthenticated(authenticated);
        };
        checkAuth();
    }, []);

    return isAuthenticated;
};